import { c as _c } from "react/compiler-runtime";
import { isGroupProcessingSelector } from "@store/groups/groups-selector";
import { useAppSelector } from "@store/store-helper";
import { GroupCardTop } from "@components/group-card/group-card-top";
import { GroupCardBottom } from "@components/group-card/group-card-bottom";
import { useCompanyId } from "@context-providers/company-id-provider";
import { useAppNavigation } from "@hooks/navigation/use-app-navigation";
import { useDateTime } from "@hooks/use-date-time";
import { Card } from "@flat-ui";
import { generateGroupDetailsRoute } from "@router/router-helper";
import { cardProperties, navigateOnPlainClick } from "@utils/ui-utils";

/**
 * A card that summarizes the group info
 */
export function GroupCard(t0) {
  const $ = _c(29);
  const {
    group
  } = t0;
  const companyId = useCompanyId();
  const {
    navigateToGroupDetails
  } = useAppNavigation();
  const {
    formatDate
  } = useDateTime();
  let t1;
  if ($[0] !== group.id) {
    t1 = isGroupProcessingSelector(group.id);
    $[0] = group.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isGroupProcessing = useAppSelector(t1);
  let t2;
  if ($[2] !== companyId || $[3] !== group.id) {
    t2 = generateGroupDetailsRoute(companyId, group.id);
    $[2] = companyId;
    $[3] = group.id;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== companyId || $[6] !== group.id || $[7] !== navigateToGroupDetails) {
    t3 = event => navigateOnPlainClick(event, () => navigateToGroupDetails({
      companyId,
      groupId: group.id
    }));
    $[5] = companyId;
    $[6] = group.id;
    $[7] = navigateToGroupDetails;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== group) {
    t4 = <GroupCardTop group={group} />;
    $[9] = group;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== formatDate || $[12] !== group.createdAt) {
    t5 = formatDate(group.createdAt);
    $[11] = formatDate;
    $[12] = group.createdAt;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t5) {
    t6 = <>Created: <var>{t5}</var></>;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== group.name) {
    t7 = <var>{group.name}</var>;
    $[16] = group.name;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== group) {
    t8 = <GroupCardBottom group={group} />;
    $[18] = group;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      height: cardProperties.height,
      marginTop: cardProperties.marginTop
    };
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== isGroupProcessing || $[22] !== t2 || $[23] !== t3 || $[24] !== t4 || $[25] !== t6 || $[26] !== t7 || $[27] !== t8) {
    t10 = <Card dataTestId="group-card" loading={isGroupProcessing} href={t2} onClick={t3} media={t4} subheader={t6} title={t7} footer={t8} sx={t9} />;
    $[21] = isGroupProcessing;
    $[22] = t2;
    $[23] = t3;
    $[24] = t4;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
}